/* istanbul ignore file */
import { isErrorResponse } from '@standardnotes/responses';
import { PrefKey } from '@standardnotes/models';
import { AbstractService } from '../Service/AbstractService';
export class AuthenticatorManager extends AbstractService {
    constructor(authenticatorApiService, preferencesService, internalEventBus) {
        super(internalEventBus);
        this.authenticatorApiService = authenticatorApiService;
        this.preferencesService = preferencesService;
        this.internalEventBus = internalEventBus;
    }
    async list() {
        try {
            const result = await this.authenticatorApiService.list();
            if (isErrorResponse(result)) {
                return [];
            }
            const authenticatorNames = this.getAuthenticatorNamesFromPreferences();
            const nameDecoratedAuthenticators = result.data.authenticators.map((authenticator) => ({
                id: authenticator.id,
                name: authenticatorNames.has(authenticator.id)
                    ? authenticatorNames.get(authenticator.id)
                    : 'Security Key',
            }));
            return nameDecoratedAuthenticators;
        }
        catch {
            return [];
        }
    }
    async delete(authenticatorId) {
        try {
            const result = await this.authenticatorApiService.delete(authenticatorId.value);
            if (isErrorResponse(result)) {
                return false;
            }
            const authenticatorNames = this.getAuthenticatorNamesFromPreferences();
            authenticatorNames.delete(authenticatorId.value);
            await this.preferencesService.setValue(PrefKey.AuthenticatorNames, JSON.stringify([...authenticatorNames]));
            return true;
        }
        catch {
            return false;
        }
    }
    async generateRegistrationOptions() {
        try {
            const result = await this.authenticatorApiService.generateRegistrationOptions();
            if (isErrorResponse(result)) {
                return null;
            }
            return result.data.options;
        }
        catch {
            return null;
        }
    }
    async verifyRegistrationResponse(userUuid, name, registrationCredential) {
        try {
            const result = await this.authenticatorApiService.verifyRegistrationResponse(userUuid.value, name, registrationCredential);
            if (isErrorResponse(result)) {
                return false;
            }
            const authenticatorNames = this.getAuthenticatorNamesFromPreferences();
            authenticatorNames.set(result.data.id, name);
            await this.preferencesService.setValue(PrefKey.AuthenticatorNames, JSON.stringify([...authenticatorNames]));
            return true;
        }
        catch {
            return false;
        }
    }
    async generateAuthenticationOptions(username) {
        try {
            const result = await this.authenticatorApiService.generateAuthenticationOptions(username.value);
            if (isErrorResponse(result)) {
                return null;
            }
            return result.data.options;
        }
        catch {
            return null;
        }
    }
    getAuthenticatorNamesFromPreferences() {
        let authenticatorNames = new Map();
        const authenticatorNamesFromPreferences = this.preferencesService.getValue(PrefKey.AuthenticatorNames);
        if (authenticatorNamesFromPreferences !== undefined) {
            try {
                authenticatorNames = new Map(JSON.parse(authenticatorNamesFromPreferences));
            }
            catch {
                authenticatorNames = new Map();
            }
        }
        return authenticatorNames;
    }
}
